module.exports = __webpack_public_path__ + "static/media/1_A1_10.0f7d1ebf.png";